import { set } from 'lodash-es';
import { redirect } from 'react-router-dom';

export * from './address';
export * from './country';



export const convertDataTypes = (data, typeSpecs) => {
    const convertedData = {};

    for (const [key, value] of Object.entries(data)) {
        //Skip empty
        if (value === null || value === undefined) {
            continue
        }
        if (key in typeSpecs) {
            const conversionFn = typeSpecs[key];
            if (typeof conversionFn === 'function') {
                try {
                    convertedData[key] = conversionFn(value);
                } catch (error) {
                    throw new Error(`Error converting value for key '${key}': ${error.message}`);
                }
            } else {
                throw new Error(`Invalid conversion function specified for key '${key}'`);
            }
        } else {
            convertedData[key] = value; // Preserve non-specified keys
        }
    }

    return convertedData;
}

export const sleep = (ms = 2000) => {
    console.warn('Kindly remember to remove `sleep`');
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export const nestedFormdataToJson = (data) => {
    const obj = {}
    for (const [path, value] of Object.entries(data)) {
        if (path.startsWith('meta')) {
            set(obj, path, value);
        }
    }
    return obj
}

export const removeEmpty = (obj) => Object.fromEntries(Object.entries(obj).filter((([, v]) => v !== null && v !== undefined)))

export const objectToSearchParams = (obj) => {
    const params = new URLSearchParams();

    for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
            const value = obj[key];

            if (typeof value === 'object' && value !== null) {
                for (const subKey in value) {
                    if (Object.hasOwnProperty.call(value, subKey)) {
                        params.append(`${key}[${subKey}]`, value[subKey]);
                    }
                }
            } else {
                params.set(key, value);
            }
        }
    }

    return params.toString();
}

export function searchParamsToObject(searchParams) {
    const obj = {};
    for (const [key, value] of searchParams.entries()) {
        const keys = key.split('[');
        let currentObj = obj;
        for (let i = 0; i < keys.length; i++) {
            const k = keys[i].replace(']', '');
            if (!currentObj[k]) {
                if (i === keys.length - 1) {
                    currentObj[k] = value;
                } else {
                    currentObj[k] = {};
                }
            }
            currentObj = currentObj[k];
        }
    }
    return obj;
}

// Persistent list filters, same behaviour as the ERP: the last applied filters of
// a list are kept per browser and restored when the list is opened without any
// filter in the URL. Free-text search is not persisted.
const readStoredFilters = (storageKey) => {
    try {
        const value = JSON.parse(localStorage.getItem(storageKey))
        return value && typeof value === 'object' ? value : null
    } catch {
        return null
    }
}

export const savePersistentFilters = (storageKey, filters) => {
    const persistent = Object.fromEntries(
        Object.entries(filters ?? {}).filter(([k, v]) => k !== 'search' && v !== null && v !== undefined && v !== '')
    )
    try {
        if (Object.keys(persistent).length > 0) {
            localStorage.setItem(storageKey, JSON.stringify(persistent))
        } else {
            localStorage.removeItem(storageKey)
        }
    } catch {
        // Storage unavailable (private mode): filters simply aren't remembered.
    }
}

export const getRedirectWithSavedFilters = (request, storageKey) => {
    const url = new URL(request.url)
    const hasFilterInUrl = Array.from(url.searchParams.keys()).some((k) => k.startsWith('filter['))
    if (hasFilterInUrl) return null
    const saved = readStoredFilters(storageKey)
    if (!saved || Object.keys(saved).length === 0) return null
    const nextSearchParams = objectToSearchParams({
        ...searchParamsToObject(url.searchParams),
        filter: removeEmpty(saved),
    })
    return redirect(`${url.pathname}?${nextSearchParams}`)
}

